import React from "react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/SectionDivider";

const STEPS = [
  {
    title: "Client Onboarding",
    body: "A private consultation, KYC, and a detailed risk profile to understand your global objectives.",
  },
  {
    title: "Account Setup",
    body: "Interactive Brokers and Citibank accounts opened in your own name in the United States.",
  },
  {
    title: "Funding Your Vault",
    body: "Remit from your Indian bank account via RBI's LRS — fully legal, fully documented.",
  },
  {
    title: "Portfolio Management",
    body: "NAG ANALYTIX deploys capital into a curated set of global monopolies with conviction.",
  },
  {
    title: "Access Anywhere",
    body: "Withdraw to any bank globally. No lock-ins. Your wealth, on your terms.",
  },
];

const GetStarted = () => {
  return (
    <section
      id="get-started"
      data-testid="get-started-section"
      className="relative bg-[#111111] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Eyebrow testId="get-started-eyebrow">Getting Started</Eyebrow>
          <h2
            data-testid="get-started-heading"
            className="font-serif-display text-[#C9960C] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl"
          >
            How To Get Started
          </h2>
          <p className="mt-6 max-w-2xl text-[#F8F6F0]/70 text-base sm:text-lg leading-relaxed">
            A discreet, step-by-step process — from first conversation to global compounding.
          </p>
        </Reveal>

        <div className="mt-16 relative">
          {/* vertical timeline line */}
          <div className="hidden md:block absolute left-[42px] top-2 bottom-2 w-px bg-[#C9960C]/30" aria-hidden="true" />

          <ol className="space-y-8">
            {STEPS.map((s, idx) => (
              <Reveal key={s.title} delay={idx * 0.08}>
                <li
                  data-testid={`start-step-${idx + 1}`}
                  className="relative md:pl-28 flex flex-col md:block"
                >
                  {/* numbered token */}
                  <div className="absolute left-0 top-0 hidden md:flex items-center justify-center w-[86px]">
                    <div className="relative w-[86px] h-[86px] border border-[#C9960C] bg-[#080808] flex items-center justify-center">
                      <span className="font-serif-display text-[#F5D485] text-3xl">
                        {String(idx + 1).padStart(2, "0")}
                      </span>
                    </div>
                  </div>

                  <div className="bg-[#1C1C1C] border border-[#C9960C]/40 border-t-2 border-t-[#C9960C] p-8 md:p-10">
                    <div className="md:hidden mb-3 text-[#C9960C] font-serif-display text-2xl">
                      {String(idx + 1).padStart(2, "0")}
                    </div>
                    <h3 className="font-serif-display text-[#F5D485] text-2xl sm:text-3xl tracking-tight mb-3">
                      {s.title}
                    </h3>
                    <p className="text-[#F8F6F0]/80 leading-relaxed">{s.body}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
